import { EventPanelFormType, PhoneCallOption } from '@mark43/cad-api';
import { UseFormReturn, useWatch } from 'react-hook-form';

export function useShouldRefreshE911Calls(form: UseFormReturn<EventPanelFormType>) {
    const phoneCall = useWatch({
        control: form.control,
        name: 'phoneCall',
    }) as PhoneCallOption | null;
    const eventOrigin911 = useWatch({
        control: form.control,
        name: 'eventOrigin911',
    }) as boolean | null;

    return !!(eventOrigin911 || phoneCall);
}
